import {createSlice} from '@reduxjs/toolkit'
import {BrandType, EnabledBrands} from '@daedalus/core/src/brand/types'

interface MetaState {
  brand: BrandType
}

export const initialState: MetaState = {
  brand: undefined
}

const {reducer} = createSlice({
  name: 'meta',
  initialState,
  reducers: {}
})

export default reducer
